<template>
  <div >
    <LoginAccountTab :activeName="activeName" />
    <div class="content-container" v-permission="'currentAccount'" v-loading="loading">
      <ContentBox>
        <DataForm class="content-form">
          <div class="el-form-item el-form-item--medium">
            <label class="el-form-item__label">
              <i class="el-icon-bangzhu"></i>
              <span>登录账号</span>
            </label>
            <div class="el-form-item__content">
              <template v-if="userAccount">
               <span> {{userAccount}}</span>
              </template>
              <template v-else>
                  <span>{{encryptLoginAccount}}</span>
              </template>
              <ResetLoginName :account="userAccount" />
            </div>
          </div>
          <div class="el-form-item el-form-item--medium">
            <label class="el-form-item__label">
              <i class="el-icon-lock"></i>
              <span>登录密码</span>
            </label>
            <div class="el-form-item__content">
              <span>********</span>
              <ResetPassword :account="userAccount" />
            </div>
          </div>
          <div class="el-form-item el-form-item--medium">
            <label class="el-form-item__label">
              <i class="el-icon-cc-jiaose"></i>
              <span>账号名称</span>
            </label>
            <div class="el-form-item__content">
              <span>{{userName}}</span>
              <ResetAccountName />
            </div>
          </div>
          <div class="el-form-item el-form-item--medium">
            <label class="el-form-item__label">
              <i class="el-icon-phone-outline"></i>
              <span>手机号</span>
            </label>
            <div class="el-form-item__content">
              <span>{{encryptLoginAccount || '暂无'}}</span>
              <ResetLoginAccount type="phone" :account="encryptLoginAccount" />
            </div>
          </div>
          <div class="el-form-item el-form-item--medium">
            <label class="el-form-item__label">
              <i class="el-icon-cc-mail"></i>
              <span>邮件地址</span>
            </label>
            <div class="el-form-item__content">
              <span>{{encryptEmail || '暂无'}}</span>
              <template v-if="encryptEmail">
                <ResetLoginAccount type="email" :account="encryptEmail" />
              </template>
              <template v-else>
                <ResetLoginEmail type="email" :account="encryptEmail"  />
              </template>
              <!--  -->
            </div>
          </div>
        </DataForm>
      </ContentBox>
      <!-- <ContentBox title="操作日志" class="content-box">
        <Table
          :props="logTable.props"
          :header="logTable.header"
          :data="logTable.data"
        />
      </ContentBox> -->
    </div>
  </div>
</template>

<script>
import LoginAccountTab from './components/LoginAccountTab'
import ResetLoginAccount from './loginAccountInfoActions/ResetLoginAccount'
import ResetPassword from './loginAccountInfoActions/ResetPassword'
import ResetAccountName from './loginAccountInfoActions/ResetAccountName'
import ResetLoginName from './loginAccountInfoActions/ResetLoginName'
import ResetLoginEmail from './loginAccountInfoActions/ResetLoginEmail'
export default {
  components: {
    LoginAccountTab,
    ResetLoginAccount,
    ResetPassword,
    ResetAccountName,
    ResetLoginName,
    ResetLoginEmail
  },
  data() {
    return {
      activeName: 'loginAccountInfo',
      activeStep: 0,
      verifyOptions: [
        { label: '旧密码', value: 'password' },
        { label: '手机验证', value: 'phone' },
        { label: '邮箱验证', value: 'email' }
      ],
      passwordForm: {
        verifyWay: 'password',
        verifyWayCode: undefined,
        newPassword: undefined,
        newPasswordAgain: undefined,
        verificationCode: undefined
      },
      loading: false,
      logTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '操作时间',
            align: 'left',
            prop: 'createTime',
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return h('TimeFormat', {
                props: {
                  value: row.createTime
                }
              })
            }
          },
          {
            label: '操作人',
            prop: 'operator',
            align: 'left',
            'show-overflow-tooltip': true
          },
          {
            label: '操作类型',
            prop: 'type',
            align: 'left',
            'show-overflow-tooltip': true
          },
          {
            label: '执行结果',
            prop: 'description',
            align: 'left',
            'show-overflow-tooltip': true
          }
        ],
        data: []
      },
      updateUsreInfo: {}
    }
  },
  computed: {
    encryptLoginAccount() {
      const user = this.$service.state.user || {}
      const phone = user.phone || ''
      return phone
        ? phone.substring(0, 3) + ' **** ' + phone.substring(7)
        : ''
    },
    encryptEmail() {
      const user = this.$service.state.user || {}
      const email = user.email || ''
      const markIndex = email.indexOf('@')
      return email
        ? email.charAt(0) + '******' + email.substring(markIndex - 1)
        : ''
    },
    userName() {
      const user = this.$service.state.user || {}
      return user.userName
    },
    userAccount() {
      const user = this.$service.state.user || {}
      return user.userAccount
    }
  },
  methods: {
    fetchData() {
      // 操作日志接口
      this.loading = true
      this.$service.getUserLog().then(data => {
        this.logTable.data = data.agentAccountLogList || []
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  },
  created() {
    // this.fetchData()
  }
}
</script>

<style lang="stylus" scoped>
.content-container {
  margin: 16px;
}

// .content-form {
//   width: 405px;
// }

>>>.content-box__main {
  margin: 24px 32px;
}

>>>.title {
  padding-left: 32px;
}
.el-form-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom 16px
}
.el-form-item__label {
  display flex
  flex-direction: row;
  align-items: center;
  padding-right 28px
}
.el-form-item__label i {
  color #FF8B00
  // border 1px solid #ff8b00
  border-radius 50%
  background rgba(255,139,0,0.15)
  margin-right 11px
  font-size 12px
  padding 4px
}
.el-form-item__label span {
  width:70px;
  height:22px;
  font-size:14px;
  font-weight:400;
  color:rgba(0,0,0,0.85);
  line-height:22px;
  text-align left
}
.el-form-item__content {
  display flex
  flex-direction row
  align-items center
  justify-content space-between
}
.el-form-item__content>span {
  min-width:190px;
  height:22px;
  font-size:14px;
  font-weight:400;
  color:rgba(0,0,0,0.65);
  line-height:22px;
  margin-right 10px
  // margin-right 98px
  }
</style>
